import { toTitleCase } from '@vestigas/utils';

export type FeatureType = 'boolean' | 'number';

export type FeatureConfig =
  | {
      type: 'boolean';
      default: boolean;
    }
  | {
      type: 'number';
      default: number;
    };

export const COMPANY_ACCOUNT_FEATURES = {
  // List features in desired display order (alphabetical with loadDlnsAmount last)
  accessArchive: { default: false, type: 'boolean' },
  agentChat: { default: false, type: 'boolean' },
  businessPartnerSettings: { default: false, type: 'boolean' },
  clientPortal: { default: false, type: 'boolean' },
  concreteDiary: { default: false, type: 'boolean' },
  createDeliveryNote: { default: false, type: 'boolean' },
  createDemoDlns: { default: true, type: 'boolean' },
  customerSubscription: { default: false, type: 'boolean' },
  dataSyncUi: { default: false, type: 'boolean' },
  deactivatedCompanyAccount: { default: false, type: 'boolean' },
  disableGps: { default: false, type: 'boolean' },
  disableInvoices: { default: false, type: 'boolean' },
  dlnListV2: { default: false, type: 'boolean' },
  enableFastScan: { default: false, type: 'boolean' },
  enableValidatedScan: { default: false, type: 'boolean' },
  esgAnalytics: { default: false, type: 'boolean' },
  esgMaterialMatcher: { default: false, type: 'boolean' },
  flixbeton: { default: false, type: 'boolean' },
  invoiceListV2: { default: false, type: 'boolean' },
  loadDlnsAmount: { default: 0, type: 'number' },
  manageProductPrices: { default: false, type: 'boolean' },
  manualInvoiceCheckingPipeline: { default: false, type: 'boolean' },
  moduleCallOffs: { default: false, type: 'boolean' },
  moduleContracts: { default: false, type: 'boolean' },
  moduleInvoiceRestriction: { default: false, type: 'boolean' },
  noPrivacyStatement: { default: false, type: 'boolean' },
  packageBasicRestriction: { default: false, type: 'boolean' },
  pgDlnAnalytics: { default: false, type: 'boolean' },
  pgDlnAttachments: { default: false, type: 'boolean' },
  pgDlnBulk: { default: false, type: 'boolean' },
  pgDlnChains: { default: false, type: 'boolean' },
  pgDlnDetail: { default: false, type: 'boolean' },
  pgDlnList: { default: false, type: 'boolean' },
  pgDlnSearch: { default: false, type: 'boolean' },
  pgDlnTransformed: { default: false, type: 'boolean' },
  pgDlnVadmin: { default: false, type: 'boolean' },
  productAnalyticsTools: { default: true, type: 'boolean' },
  releaseSyncedData: { default: false, type: 'boolean' },
  sentryGoogleAnalyticsDisabled: { default: false, type: 'boolean' },
  serviceNotes: { default: false, type: 'boolean' },
  supplierOverview: { default: true, type: 'boolean' },
  supplierOverviewForceCsRouting: { default: false, type: 'boolean' },
  supplierOverviewRequestSupplier: { default: false, type: 'boolean' },
  suppliersKanban: { default: false, type: 'boolean' },
  userInDlnHistory: { default: true, type: 'boolean' }, // Keep this as the last item
} as const satisfies Record<string, FeatureConfig>;

export type CompanyAccountFeature = keyof typeof COMPANY_ACCOUNT_FEATURES;

// Get feature names in the order they are defined in the object
export const COMPANY_ACCOUNT_FEATURE_KEYS = Object.keys(
  COMPANY_ACCOUNT_FEATURES,
) as CompanyAccountFeature[];

// Helper function to convert a camel case string to title case.
export const camelCaseToTitleCase = (name: string) =>
  toTitleCase(name.replaceAll(/([A-Z])/g, ' $1'));

// Helper function to convert a snake case string to title case.
export const snakeCaseToTitleCase = (name: string) =>
  toTitleCase(name.replaceAll('_', ' '));
